<div class="my-ticket-wrap">
    <ng-container *ngIf="isUsserLogged; else notLogged">
        <div class="date-picker-wrap">
            <ng-container i18n="My Tickets Period@@myTicketsPeriod">Period</ng-container>:
            <div class="date-picker">
                <mat-form-field>
                    <input matInput [matDatepicker]="matDateFrom" [max]="maxDate" [ngModel]="dateFrom" (dateChange)="dateFromChanged($event)" (click)="matDateFrom.open()" >
                    <mat-datepicker-toggle matSuffix [for]="matDateFrom"></mat-datepicker-toggle>
                    <mat-datepicker touchUi #matDateFrom></mat-datepicker>
                </mat-form-field>

                <span class="divider">-</span>

                <mat-form-field>
                    <input matInput [matDatepicker]="matDateTo" [max]="maxDate" [ngModel]="dateTo" (dateChange)="dateToChanged($event)" (click)="matDateTo.open()">
                    <mat-datepicker-toggle matSuffix [for]="matDateTo"></mat-datepicker-toggle>
                    <mat-datepicker touchUi #matDateTo></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="loaded-ticket"><ng-container i18n="My Tickets filter@@myTicketsTabNoLoaded">Učitano</ng-container>: <span class="bold">{{myTickets.length}}</span></div>
        </div>
        <div class="filter-ticket">
            <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Active" (click)="changeTicketsFilter(ticketFilterStatusEnum.Active)">A</span>
            <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Win" (click)="changeTicketsFilter(ticketFilterStatusEnum.Win)">D</span>
            <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Cashout" (click)="changeTicketsFilter(ticketFilterStatusEnum.Cashout)">CO</span>
            <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Lost" (click)="changeTicketsFilter(ticketFilterStatusEnum.Lost)">G</span>
            <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Storno" (click)="changeTicketsFilter(ticketFilterStatusEnum.Storno)">S</span>
            <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.Cashback" (click)="changeTicketsFilter(ticketFilterStatusEnum.Cashback)">CB</span>
            <span class="filter-option" [class.selected]="ticketsFilterStatus == ticketFilterStatusEnum.All" (click)="changeTicketsFilter(ticketFilterStatusEnum.All)" i18n="My Tickets tab all tickets Radio text@@myTicketsTabAll">SVI</span>
        </div>
        <div class="ticket-item {{ticketStatusEnum[ticket.status.code] | lowercase}}" *ngFor="let ticket of myTickets" (click)="openTicketDetails(ticket)">
            <div class="flex">
                <div class="flex-column">
                    <span class="highlight">{{ticket.ticketNumber}}</span>
                    <span><ng-container i18n="Ticket Pay in text@@TicketPayIn">Uplata</ng-container>: <br>{{ticket.stake | number:'1.2-2'}} {{currency}}</span>
                </div>
                <div class="flex-column">
                    <span class="highlight">
                        <ng-container i18n="My Tickets played ticket number of events@@myTicketsTabEvents">Parovi</ng-container>: {{ticket.numberOfMatches}}</span>
                    <span>
                        <ng-container i18n="Ticket Pay out text@@TicketPayOut">Isplata</ng-container>: <br>{{ticket.possibleMaxWin | number:'1.2-2'}} {{currency}}
                    </span>
                </div>
            </div>
            <div class="flex ticket-status-wrap">
                <!-- <div class="flex ticket-status {{ticketStatusEnum[ticket.status.code] | lowercase}}" >
                    <span>{{ticket.status.name}}</span>
                </div> -->
                <span class="flex ticket-cashout btn outline-primary" *ngIf="ticket.cashoutValue != null && ticket.cashoutValue != ''" (click)="sellBet(ticket); $event.stopPropagation();">
                    <img class="cashout-icon" src="assets/img/CashOUT.svg">
                    <span i18n="Casheback text@@Casheback">CashOut</span>: {{ticket.cashoutValue | number:'1.2-2'}} {{currency}}
                </span>
            </div>
        </div>

        <div class="no-result" *ngIf="myTickets && myTickets.length === 0">
            <span i18n="there are no tickets for the selected filter@@TicketDoesNotExist">Nema tiketa za odabrani filter</span>
        </div>
    </ng-container>

    <ng-template #notLogged>
        <div class="no-result">
            <span i18n="ticket Confirm not logged in@@ConfirmTicketNotLoggedIn">Morate biti ulogovani</span>.
        </div>
    </ng-template>
</div>
